import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { TbTrash } from 'react-icons/tb';

const EditDeleteStageModal = ({ show, onHide, onConfirm, stageName }) => {
  return (
    <Modal show={show} onHide={onHide} centered size="md">
      <Modal.Body className="text-center p-5">
        <div className="mx-auto mb-4" style={{
          width: '80px', height: '80px', backgroundColor: '#FEE2E2',
          borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <TbTrash size={40} color="#EF4444" />
        </div>

        <h4 className="fw-semibold mb-2">Confirm Delete</h4>
        <p className="text-muted mb-4">
          You want to delete <strong>{stageName}</strong>.<br />
          This cannot be undone once you delete.
        </p>

        <div className="d-flex gap-3 justify-content-center">
          <Button variant="light" className="px-4" onClick={onHide}>Cancel</Button>
          <Button variant="danger" className="px-4" onClick={onConfirm}>
            Yes, Delete
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditDeleteStageModal;